import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";
import { updateUserProfile } from "../../store/slices/userSlice";
import AccountLayout from "../../blocs/AccountLayout";
import TextInputFormik from "../../components/inputs/TextInuputformik";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import LocationAutocomplete from "../../components/LocationAutocomplete"; // Ensure this is properly imported
import { useLoadScript } from "@react-google-maps/api";
import { toast } from "react-toastify";

const Profile = () => {
  const libraries = ["places"];
  const dispatch = useDispatch();
  const { user, isAuthenticated, adresse_facturation, loading, error } =
    useSelector((state) => state.user);
  const { selectedEtablissement, isLoading } = useSelector(
    (state) => state.etablissements
  );
  // console.log("selected ", selectedEtablissement);
  const isProfessional =
    user?.is_professional === 1 || user?.is_professional === true;
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const initialValues = {
    nom: user?.nom || "",
    prenom: user?.prenom || "",
    email: user?.email || "",
    phone_number: user?.phone_number || "",
    siret: user?.siret || "",
    company_name: user?.company_name || "",
    company_address:
      selectedEtablissement?.adresse_postale ||
      user?.company_address ||
      user?.etablissement?.adresse_postale,

    // adresse_facturation: adresse_facturation?.numero_rue,
    ...(user?.role === "prestataire"
      ? { tva: user?.tva || "" }
      : user?.role === "user"
      ? { adresse_facturation: adresse_facturation?.numero_rue || "" }
      : {}),
    is_default: true,
  };

  const validationSchema = Yup.object().shape({
    nom: Yup.string().required("Nom requis"),
    prenom: Yup.string().required("Prénom requis"),
    email: Yup.string()
      .email("Email invalide")
      .required("Adresse e-mail requis"),
    phone_number: Yup.string()
      .required("Numéro de téléphone requis")
      .test("is-valid-phone", "Numéro de téléphone invalide", (value) =>
        isValidPhoneNumber(value || "")
      ),
    ...(isProfessional && {
      siret: Yup.string()
        .required("SIRET requis")
        .matches(/^\d{14}$/, "Le SIRET doit contenir exactement 14 chiffres"),
      company_name: Yup.string().required("Dénomination requis!"),
      company_address: Yup.string().required("Adresse entreprise requise"),
      // adresse_facturation: Yup.string().required(
      //   "Adresse de facturation requise"
      // ),
      ...(user?.role === "prestataire" && {
        tva: Yup.string().matches(
          /^FR\d{2}\d{9}$/,
          "Format TVA invalide (ex: FR12XXXXXXXXX)"
        ),
      }),
    }),
  });

  const handleLocationSelect = (
    place,
    setFieldValue,
    setFieldTouched,
    fieldName
  ) => {
    const address = place?.description || "";
    // console.log("address:",place?.description);
    setFieldValue(fieldName, address);
    setFieldTouched(fieldName, true);
    if (isLoaded && window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
    }
  };

  if (!isAuthenticated)
    return <div>Veuillez vous connecter pour accéder à votre profil.</div>;

  return (
    <AccountLayout bgColor={"bgColor"}>
      <h3>Informations personnelles</h3>
      {error && <div className="alert alert-danger">{error}</div>}

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { isSubmitting, setSubmitting, setStatus }) => {
          // console.log("isSubmitting:", isSubmitting, "loading:", loading);
          try {
            dispatch(updateUserProfile(values))
              .unwrap()
              .then((response) => {
                // console.log("Réponse de updateUserProfile :", response?.adresse_facturation?.adresse_complete);
                localStorage.setItem(
                  "adresse_facturation",
                  JSON.stringify(response.adresse_facturation)
                );
                // setStatus({ success: "Profil mis à jour avec succès" });
                toast.success("Profil mis à jour avec succès");
                setSubmitting(false);
                setTimeout(() => setStatus({ success: "" }), 3000);
              })
              .catch(() => setSubmitting(false));
          } catch (error) {
            setSubmitting(false);
            setStatus({
              error:
                "Une erreur s'est produite lors de la mise à jour du profil.",
            });
          }
        }}
      >
        {({
          isSubmitting,
          status,
          setFieldValue,
          setFieldTouched,
          fieldName,
          values,
        }) => (
          <Form>
            {status?.success && (
              <div className="alert alert-success">{status.success}</div>
            )}

            <div className="row pd-bt-28">
              <div className="col-md-6 form-group mt-16">
                <TextInputFormik
                  label="Adresse e-mail*"
                  name="email"
                  type="email"
                  className="form-control body"
                  placeholder="john@gmail.com"
                />
              </div>

              <div className="col-md-6 form-group mt-16">
                <div className="input-wrapper ">
                  <label className="form-label">Numéro de téléphone*</label>
                  <PhoneInput
                    excludeCountries={[]}
                    international
                    defaultCountry="FR"
                    value={values.phone_number}
                    onChange={(value) => setFieldValue("phone_number", value)}
                    onBlur={() => setFieldTouched("phone_number", true)}
                    id="phone_number"
                    name="phone_number"
                  />
                </div>
                <ErrorMessage
                  name="phone_number"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="col-md-6 form-group mt-16">
                <TextInputFormik
                  label="Nom*"
                  name="nom"
                  type="text"
                  className="form-control"
                  placeholder="Votre nom"
                />
              </div>

              <div className="col-md-6 form-group mt-16">
                <TextInputFormik
                  label="Prénom*"
                  name="prenom"
                  type="text"
                  className="form-control"
                  placeholder="Votre prénom"
                />
              </div>

              {isProfessional && (
                <>
                  <div className="col-md-6 form-group mt-16">
                    <TextInputFormik
                      label="SIRET*"
                      name="siret"
                      type="text"
                      className="form-control"
                      placeholder="SIRET"
                    />
                  </div>

                  <div className="col-md-6 form-group mt-16">
                    <TextInputFormik
                      label="Dénomination*"
                      name="company_name"
                      type="text"
                      className="form-control"
                      placeholder="Nom de l’entreprise"
                    />
                  </div>
                  <div className="col-md-6 input-wrapper form-group mt-16">
                    <label className="form-label">Adresse entreprise*</label>
                    <div className="relative">
                      <LocationAutocomplete
                        onLocationSelect={(place) =>
                          handleLocationSelect(
                            place,
                            setFieldValue,
                            setFieldTouched,
                            "company_address"
                          )
                        }
                        isGoogleLoaded={isLoaded}
                        value={initialValues.company_address}
                      />
                    </div>
                    <ErrorMessage
                      name="company_address"
                      component="div"
                      className="text-danger small"
                    />
                  </div>
                  {user?.role == "user" && (
                    <div className="col-md-6 input-wrapper form-group mt-16">
                      <label className="form-label">
                        Adresse de facturation
                      </label>
                      <div className="relative">
                        <LocationAutocomplete
                          onLocationSelect={(place) =>
                            handleLocationSelect(
                              place,
                              setFieldValue,
                              setFieldTouched,
                              "adresse_facturation"
                            )
                          }
                          isGoogleLoaded={isLoaded}
                          value={initialValues.adresse_facturation}
                        />
                      </div>
                      <ErrorMessage
                        name="adresse_facturation"
                        component="div"
                        className="text-danger small"
                      />
                    </div>
                  )}

                  {user?.role == "prestataire" && (
                    <div className="col-md-6 form-group mt-16">
                      <TextInputFormik
                        label="TVA"
                        name="tva"
                        type="text"
                        className="form-control"
                        placeholder="Numéro de TVA"
                      />
                    </div>
                  )}
                </>
              )}
            </div>

            <button
              type="submit"
              className="twyny-cta-primary mt-4"
              disabled={isSubmitting || loading}
            >
              {loading ? "Enregistrement..." : "Enregistrer les modifications"}
            </button>
          </Form>
        )}
      </Formik>
    </AccountLayout>
  );
};

export default Profile;
